// Continuous horizontal marquee of logo tiles
export default function LogoMarquee({
  items,
  speed = "normal",
  renderItem,
  testId,
}) {
  const doubled = [...items, ...items];
  const speedClass =
    speed === "slow" ? "animate-marquee-slow" : "animate-marquee";
  return (
    <div className="marquee-mask overflow-hidden" data-testid={testId}>
      <div className={`flex gap-6 sm:gap-8 items-stretch w-max ${speedClass}`}>
        {doubled.map((item, i) => (
          <div key={`${item.name || item.short}-${i}`} className="shrink-0">
            {renderItem(item, i)}
          </div>
        ))}
      </div>
    </div>
  );
}
